export const pieVariants = {
  default: {
    code: 'default',
    displayName: 'Default',
    description: 'Standard pie chart with arc labels and link lines.',
    overrides: {
      props: {},
      className: null,
      styles: {}
    }
  },
  donut: {
    code: 'donut',
    displayName: 'Donut',
    description: 'Pie chart with configurable inner radius and pad angle. Shows data as a ring.',
    parameters: [
      {
        key: 'innerRadius',
        type: 'select',
        label: 'Inner Radius',
        default: '70%',
        options: [
          { value: '50%', label: '50%' },
          { value: '60%', label: '60%' },
          { value: '70%', label: '70%' },
          { value: '80%', label: '80%' }
        ]
      },
      {
        key: 'padAngle',
        type: 'select',
        label: 'Pad Angle',
        default: 1,
        options: [
          { value: 0, label: 'None' },
          { value: 1, label: 'Small' },
          { value: 2, label: 'Medium' },
          { value: 3, label: 'Large' }
        ]
      }
    ],
    resolve: (params) => ({
      props: {
        innerRadius: params.innerRadius,
        padAngle: params.padAngle
      },
      className: null,
      tableClassName: null,
      styles: {
        label: { show: false },
        labelLine: { show: false }
      }
    })
  }
}
